import Enums from "../../../enums/enums";
import helper from "../../../helper/shareHelper";
import * as api from "../../../service/ApiSevice";
export const actions = {
  DoSetForgotPwd({ commit, state }, username) {
    state.setForgotPwdLoadingStatusType = Enums.LoadingStatusType.Loading;
    api.UserService.DoSetForgotPwd(username).then((res) => {
      if (res.responseCode && res.responseCode.IsSuccess()) {
        commit("MutationSetForgotPwd");
      } else {
        state.setForgotPwdLoadingStatusType = Enums.LoadingStatusType.Failed;
      }
    });
  },
  DoGetForgotPwd({ commit, state }, _input) {
    state.getForgotPwdLoadingStatusType = Enums.LoadingStatusType.Loading;
    api.UserService.DoGetForgotPwd(_input).then((res) => {
      if (res.data.responseCode.IsSuccess()) {
        commit("MutationGetForgotPwd", res.data.forgotPwd);
      } else {
        state.getForgotPwdLoadingStatusType = Enums.LoadingStatusType.Failed;
      }
    });
  },
  DoResetPwd({ commit, state }, _input) {
    state.resetPwdLoadingStatusType = Enums.LoadingStatusType.Loading;
    let passwordToken = helper.CreateToken(_input.newPassword);
    let input = {
      newPassword: passwordToken,
      forgotPasswordData: _input.forgotPasswordData,
    };

    api.UserService.DoResetPwd(input).then((res) => {
      if (res.data.responseCode.IsSuccess()) {
        commit("MutationResetPwdStatus", res.data.resetPwd);
        commit("MutationResetPwd", Enums.LoadingStatusType.Success);
      } else {
        commit("MutationResetPwd", Enums.LoadingStatusType.Failed);
        let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
        store.dispatch("SetAlertMessage", {
          alertMessage: alertMessage,
          typeMessage: Enums.TypeComponentNoti.error,
        });
      }
    });
  },
};
